import * as yup from "yup";
import { useMutation } from "@tanstack/react-query";
import { HTTP_ENDPOINTS } from "../../consts/api";
import { http } from "../../services/HttpService";

const requestSchema = yup.object({
  file: yup.string().required(),
  patientId: yup.number().required(),
  accountId: yup.number().required(),
});

const responseSchema = yup.object({
  filename: yup.string().required(),
  url: yup.string().required(),
});

const composeResponse = (res) => {
  return res?.data?.data;
};

export function usePublicSurveyUploadFileMutation(options = {}) {
  return useMutation(async (dto) => {
    var req = requestSchema.validateSync(dto, {
      strict: true,
    });

    var res = await http.post(HTTP_ENDPOINTS.surveys.public.uploadFile(), {
      file: req.file,
      patient_id: req.patientId,
      account_id: req.accountId,
      upload_type: "profile",
    });

    return responseSchema.validateSync(composeResponse(res), {
      strict: true,
    });
  }, options);
}
